<template>
  <div class="error">
    <img class="image huger" src="@/assets/logo.png">

    <div class="mt-lg font-md text-bold">对不起，找不到您要的模型</div>
    <div v-if="errno == 1" class="">登录口令缺失，请从云平台内打开模型编辑器。</div>
    <div v-if="errno == 2" class="">获取用户信息失败，请从云平台内打开模型编辑器。</div>
    <div v-if="errno == 3" class="">无权限，或模型已被删除，请从云平台内打开模型编辑器。</div>

    <div class="mt-lg">
      <el-button round @click="help">获取支持</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error',

  data() {
    return {
      errno: this.$route.query.errno || '',
    }
  },

  methods: {
    help() {
      this.$contactus()
    },
  }
}
</script>

<style lang="scss" scoped>
.error {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20vh;
}
</style>